import { observable, toJS, makeObservable, action, computed } from "mobx";
import { checkPageAction, copyTextToClipboard, extractErrorMessage } from "../../../utils/helpers";
import { CrudCommon } from "../_common/CrudCommon";
import { AppStore } from "~/stores/AppStore";

import _ from "lodash";

import { translateKey as t } from "../../../locales/translation";

export class UserController {
  public store: AppStore;
  public user: any = null;
  public users: Array<any> = [];

  //
  public formRef: any;
  public crudCommon: CrudCommon;
  public formMode = "create";
  public entitySnapshot = "";
  public passwordChanged = false;
  public fields: Array<any> = [
    { Header: t("lblActive", "Active"), id: "active", type: "boolean" },
    { Header: t("lblUsername", "Username"), id: "username" },
    { Header: t("lblEmail", "Email"), id: "email" },
    { Header: t("lblFirstName", "First Name"), id: "firstName" },
    { Header: t("lblLastName", "Last Name"), id: "lastName" },
    { Header: t("lblDepots", "Depots"), id: "depots" },
    { Header: t("lblRoles", "Roles"), id: "roles" },
  ];

  public depots: Array<any> = [];
  public routeGroups: Array<any> = [];
  public roles: Array<any> = [];
  public providers: Array<any> = [];

  public mainDataHasLoaded = false;
  public additionalColumnsAreVisible = false;
  public isReadOnly = false;
  public isSelectedUserReadOnly = false;
  public isFormModalVisible = false;
  public saveButtonLoading = false;
  public tableInstance: any = null;
  public deleteModal: any = { visible: false, description: "", onConfirmDelete: () => this.deleteUsers() };
  public tableIsReadOnly = true;
  // public saveModal: any = { visible: false, onConfirmSave: () => this.handleTableSubmit() }
  // public isDiscardChangesModalVisible = false
  public changePassword = false;

  public modifiedRows: any = [];
  public multiSelectKeyPressed = false;
  public shiftKeyPressed = false;
  public clickedRow: any = {};

  // Used for the form's options
  public modalOptionsLocalStorageKey = "usersFormModalOptions";
  public formFieldsSize: "small" | "middle" | "large" = "middle";
  public formModalSize: "small" | "default" | "large" = "default";
  public showNonMandatoryFields = true;
  public showFieldsIcon = false;
  public showPasswords = false;
  public prerequisitesLoaded = true;

  constructor(store) {
    this.store = store;
    this.crudCommon = new CrudCommon(this, "users");

    makeObservable(this, {
      users: observable,
      user: observable,
      formRef: observable,
      crudCommon: observable,
      formMode: observable,
      entitySnapshot: observable,
      passwordChanged: observable,
      fields: observable,
      depots: observable,
      routeGroups: observable,
      roles: observable,
      providers: observable,
      mainDataHasLoaded: observable,
      additionalColumnsAreVisible: observable,
      isReadOnly: observable,
      isSelectedUserReadOnly: observable,
      isFormModalVisible: observable,
      saveButtonLoading: observable,
      tableInstance: observable,
      deleteModal: observable,
      tableIsReadOnly: observable,
      changePassword: observable,
      modifiedRows: observable,
      multiSelectKeyPressed: observable,
      shiftKeyPressed: observable,
      clickedRow: observable,
      modalOptionsLocalStorageKey: observable,
      formFieldsSize: observable,
      formModalSize: observable,
      showNonMandatoryFields: observable,
      showFieldsIcon: observable,
      showPasswords: observable,
      prerequisitesLoaded: observable,

      //ACTIONS
      setUsers: action,
      setAdditionalColumnsAreVisible: action,
      setSaveButtonLoading: action,
      setFormMode: action,
      setEntitySnapshot: action,
      setUser: action,
      setMainDataHasLoaded: action,
      setIsFormModalVisible: action,
      setEntity: action,
      setTableInstance: action,
    });

    // This value is set in the User Routes CRUD
    this.isReadOnly = this.store.isRouteReadOnly(window.location.pathname);

    this.setFormModalOptions();
  }

  //------------------------SETTERS--------------------------------------------------------------

  public setEntity(entity: string, value: any) {
    this[entity] = value;
  }

  public setUsers(value: Array<any>) {
    this.users = value;
  }

  public setUser(value: any, key: string = null) {
    if (key === null) {
      this.user = value;
    } else if (key === "roles") {
      this.user.roles[0] = value;
    } else {
      this.user[key] = value;
    }
  }

  public setSaveButtonLoading(value: boolean) {
    this.saveButtonLoading = value;
  }

  public setAdditionalColumnsAreVisible(value: boolean) {
    this.additionalColumnsAreVisible = value;
  }

  public setIsFormModalVisible(value: boolean) {
    this.isFormModalVisible = value;
  }

  public setTableInstance(value: any) {
    this.tableInstance = value;
  }

  public setMainDataHasLoaded(value: any) {
    this.mainDataHasLoaded = value;
  }

  public setFormRef(value: any) {
    this.formRef = value;
  }

  public setEntitySnapshot(value: any) {
    this.entitySnapshot = value;
  }
  public setFormMode(value: any) {
    this.formMode = value;
  }
  // === LOADING ===
  public async loadDependencies() {
    // this.store.startOverlayLoader({
    //   description: t('lblRetrievingUsers', 'Retrieving Users...'),
    //   subDescription: t('lblLoadingPrerequisites', 'Loading Prerequisites')
    // })

    Promise.all([
      this.loadUserRoles(),
      // this.loadDepots(),
      this.loadLoginProviders(),
    ]).then(() => {
      if (this.prerequisitesLoaded) {
        Promise.all([this.loadUsers()]).then(() => {
          // Setting this variable to true enables the Create Button
          // this.store.stopOverlayLoader()
          this.setMainDataHasLoaded(true);
          this.checkPageAction();
        });
      } else {
        // this.store.stopOverlayLoader()
      }
    });
  }

  private async loadUsers() {
    // Note that the back-end will only return users who have a role equal to or less than the logged in user, for security reasons

    try {
      const users = await this.store.getData("users");
      if (users) {
        users.forEach((us) => {
          us.roleRef = us.roles[0];
        });
        this.setUsers(users);
      }

      this.setUser(null);
    } catch (err) {
      this.store.displayNotification(t("lblFailedToLoadUsers", "Failed to Load Users"), "error", true, extractErrorMessage(err));

      // this.store.stopOverlayLoader()
    }
  }

  // private loadDepots() {
  //   this.fleetStore
  //     .loadDepotsByType(
  //       (depots) => {
  //         this.depots = depots.slice().sort((a, b) => {
  //           return a.depotRef.localeCompare(b.depotRef, undefined, { numeric: true, sensitivity: 'base' })
  //         })
  //       },
  //       'all',
  //       '&active=true'
  //     )
  //     .catch((err) => {
  //       this.store.displayNotification(t('lblFailedToLoadDepots', 'Failed to Load Depots'), 'error', true, extractErrorMessage(err))

  //       this.prerequisitesLoaded = false
  //       this.store.stopOverlayLoader()
  //     })
  // }

  private async loadUserRoles() {
    try {
      const userRoles = await this.store.getData("user-roles");

      if (userRoles) {
        this.roles = userRoles.slice().sort((a, b) => a.name.localeCompare(b.name));
      }
    } catch (err) {
      this.store.displayNotification(t("lblFailedToLoadUserRoles", "Failed to Load User Roles"), "error", true, extractErrorMessage(err));

      this.prerequisitesLoaded = false;
      // this.store.stopOverlayLoader()
    }
  }

  private async loadLoginProviders() {
    try {
      const providers = await this.store.getData("login-providers?usertype=backofficeuser");

      if (providers) {
        this.providers = providers;
      }
    } catch (err) {
      this.store.displayNotification(t("lblFailedToLoadProviders", "Failed to Providers"), "error", true, extractErrorMessage(err));

      this.prerequisitesLoaded = false;
      // this.store.stopOverlayLoader()
    }
  }

  // === FORM (CREATE AND EDIT) ===
  public openEditForm = (user: any) => {
    this.setFormMode("edit");

    // If the selected user has a role that is not present in the roles array we assume that it is of a higher rank
    // Because the getData('user-roles') call returns only roles equal to or less than those of the logged in user
    if (user.roles?.length > 1) {
      user.roles.forEach((userRole) => {
        if (!this.roles.some((role) => role.roleRef === userRole)) {
          this.isSelectedUserReadOnly = true;
        }
      });
    }

    this.changePassword = false;
    this.user = toJS(user);
    // This value is used in the CrudFormModal component.
    // We use this value to know if the user has modified any fields within the form
    this.setEntitySnapshot(JSON.stringify(user));

    this.setIsFormModalVisible(true);
  };

  public saveFormUser = async () => {
    this.setSaveButtonLoading(true);
    let confirmPassword: string = this.user.confirmPassword;

    delete this.user.confirmPassword;

    this.setUser(this.user.username?.trim().toLowerCase(), "username");
    this.setUser(this.user.email?.trim().toLowerCase(), "email");

    if (this.formMode === "create") {
      await this.store
        .postData("users/", this.user)
        .then((response) => {
          // Needed to instantly re-render the Role field, in the table
          response.roleRef = response.roles[0];

          // Adds the new item to the table
          this.users.push(observable(response));
          this.reorderTable();

          this.setIsFormModalVisible(false);
          // Scrolls to the position of the new row and selects it
          this.tableInstance.handleRowSelection(response);

          this.store.displayNotification(t("lblUserCreatedSuccessfully", "User Created Successfully"), "success", true, t("lblUsername", "Username") + ": " + this.user.username);
        })
        .catch((err) => {
          this.store.displayNotification(t("lblFailedToCreateUser", "Failed to Create User"), "error", true, extractErrorMessage(err));

          // If there was an error, and therefore the user has not yet been created, puts back the confirmPassword property
          this.user.confirmPassword = confirmPassword;

          // this.store.stopOverlayLoader()
        });
    }

    if (this.formMode === "edit") {
      let payload: any = toJS(this.user);

      if (payload.roleRef) {
        delete payload.roleRef;
      }

      payload.username = payload.username?.trim().toLowerCase();
      payload.email = payload.email?.trim().toLowerCase();

      if (this.changePassword && this.user.password?.trim() && this.user.provider !== "ldapauth" && this.user.provider !== "azuread" && this.user.provider !== "google") {
        let passwordChange: any = {
          username: this.user.username,
          newPassword: this.user.password,
        };

        await this.store
          .postData("users/admin/password", passwordChange)
          .then(() => {
            if (payload.password) {
              delete payload.password;
            }

            //this.saveButtonLoading = false

            this.store
              .postData("users/" + this.user._id, payload)
              .then((updatedUser) => {
                // Needed to instantly re-render the Role field, in the table
                updatedUser.roleRef = updatedUser.roles[0];

                //updatedUser.createdAt = this.user?.createdAt
                //updatedUser.updatedAt = this.user?.updatedAt

                // Finds the index of the edited User
                const foundUserIndex: number = this.users.findIndex((user) => user._id === this.user._id);
                // Overwrites the previous data, applying the new changes
                this.users[foundUserIndex] = updatedUser;

                // Forces table re-rendering
                this.users = this.users.map((u) => u);

                this.setIsFormModalVisible(false);

                this.store.displayNotification(t("lblUserUpdatedSuccessfully", "User Updated Successfully"), "success", true, t("lblUsername", "Username") + ": " + this.user.username);
              })
              .catch((err) => {
                this.store.displayNotification(t("lblFailedToEditUser", "Failed to Edit User"), "error", true, extractErrorMessage(err));

                // this.store.stopOverlayLoader()
              });
          })
          .catch((error) => {
            //this.saveButtonLoading = false
            // this.store.stopOverlayLoader()
            if (error.response && error.response.data && error.response.data.message) {
              this.store.displayNotification(error.response.data.message, "error", true);
              return;
            }
            this.store.displayNotification(error.message, "error", true);
          });
      } else {
        await this.store
          .postData("users/" + this.user._id, payload)
          .then((updatedUser) => {
            // Needed to instantly re-render the Role field, in the table
            updatedUser.roleRef = updatedUser.roles[0];

            //updatedUser.createdAt = this.user?.createdAt
            //updatedUser.updatedAt = this.user?.updatedAt

            // Finds the index of the edited User
            const foundUserIndex: number = this.users.findIndex((user) => user._id === this.user._id);
            // Overwrites the previous data, applying the new changes
            this.users[foundUserIndex] = updatedUser;

            this.reorderTable();

            this.setIsFormModalVisible(false);

            // Scrolls to the new position of the edited row and selects it
            this.tableInstance.handleRowSelection(updatedUser, false, true);

            this.store.displayNotification(t("lblUserUpdatedSuccessfully", "User Updated Successfully"), "success", true, t("lblUsername", "Username") + ": " + this.user.username);
          })
          .catch((err) => {
            this.store.displayNotification(t("lblFailedToEditUser", "Failed to Edit User"), "error", true, extractErrorMessage(err));

            // this.store.stopOverlayLoader()
          });
      }
    }

    this.setSaveButtonLoading(false);
  };

  private setFormModalOptions = () => {
    if (localStorage.getItem("usersFormModalOptions")) {
      let localStorageObj: any = JSON.parse(localStorage.getItem("usersFormModalOptions"));

      this.formModalSize = localStorageObj.formModalSize.currentlySet;
      this.formFieldsSize = localStorageObj.formFieldsSize.currentlySet;
      this.showNonMandatoryFields = localStorageObj.showNonMandatoryFields.currentlySet;
      this.showFieldsIcon = localStorageObj.showFieldsIcon.currentlySet;
    } else {
      let usersFormModalOptions = {
        formModalSize: { default: "default", currentlySet: "default" },
        formFieldsSize: { default: "default", currentlySet: "default" },
        showNonMandatoryFields: { default: true, currentlySet: true },
        showFieldsIcon: { default: false, currentlySet: false },
      };

      localStorage.setItem("usersFormModalOptions", JSON.stringify(usersFormModalOptions));
    }
  };

  // public handleDepotsChange = (val: any, state: boolean, selectedAll: boolean) => {
  //   if (state) {
  //     if (selectedAll) {
  //       this.user.depots = this.depots.map((depot) => depot._id);
  //     } else {
  //       this.user.depots.push(val._id);
  //     }
  //   } else {
  //     if (selectedAll) {
  //       this.user.depots = [];
  //     } else {
  //       const itemIndex: number = this.user.depots.findIndex((item) => item === val._id);
  //       this.user.depots.splice(itemIndex, 1);
  //     }
  //   }
  // };

  // === DELETE ===
  public deleteUsers = async () => {
    let selectedRows: any = Object.values(this.tableInstance.multiSelectedRows.rows);
    let selectedRowsIds: Array<any> = [];
    let selectedRowsRefs: Array<string> = [];

    selectedRows.forEach((row) => selectedRowsIds.push({ _id: row }));

    // Contains the ids of the rows we are going to delete
    let payload: any = {
      items: selectedRowsIds,
    };

    // Builds an array containing the refs of the deleted rows, to show them in the notification
    selectedRowsIds.forEach((row) => {
      let user: any = this.users.find((usr) => usr._id === row._id);

      if (user && user.username) {
        selectedRowsRefs.push(user.username);
      }
    });

    await this.store
      .postData("users/bulkRemove", payload)
      .then(() => {
        // Removes the deleted rows from the table
        this.users = this.users.filter((user) => !selectedRows.some((usr) => usr === user._id));
        // Removes the deleted rows from the modifiedRows array
        this.modifiedRows = this.modifiedRows.filter((modRow) => !selectedRowsIds.some((usr) => usr._id === modRow.filter._id));

        // Deselects previously selected rows
        this.tableInstance.resetMultiselectedRows();

        if (selectedRowsIds.length === 1) {
          this.store.displayNotification(t("lblUserDeletedSuccessfully", "User Deleted Successfully"), "success", true, selectedRowsRefs.length !== 0 && selectedRowsRefs[0]);
        } else {
          this.store.displayNotification(t("lblUsersDeletedSuccessfully", "Users Deleted Successfully"), "success", true, selectedRowsRefs.length !== 0 && selectedRowsRefs.join(", "));
        }
      })
      .catch((err) => {
        this.store.displayNotification(t("lblFailedToDeleteUsers", "Failed to Delete Users"), "error", true, extractErrorMessage(err));

        // this.store.stopOverlayLoader()
      });
  };

  // === TABLE ===
  // Sorts the table by Username
  private reorderTable = () => {
    this.users = _.sortBy(this.users, ["username"]);
  };

  private handleSortingAfterTableSubmit = () => {
    let usernameHasBeenModified: boolean = false;

    // Loops through modified rows
    this.modifiedRows.forEach((modifiedUser) => {
      // Enters the conditional block only if the Username field of the modified row has been edited
      if (modifiedUser.data.username) {
        usernameHasBeenModified = true;
      }
    });

    if (usernameHasBeenModified) {
      this.reorderTable();

      // Scrolls to the new position of the (last) modified row and selects it
      const newRow: any = this.users.find((user) => user._id === toJS(this.modifiedRows[this.modifiedRows.length - 1].filter._id));
      this.tableInstance.handleRowSelection(newRow, false, true);
    }

    // Closes the editing state for the modified row
    this.tableInstance.handleCellEdit();
  };

  // public handleTableSubmit = async () => {
  //   let payload: any = {
  //     items: this.modifiedRows
  //   }

  //   this.store.startOverlayLoader(t('lblUpdatingData', 'Updating data'))

  //   // Prevents to remove required fields from the table and save successfully
  //   try {
  //     if (this.modifiedRows.some(modRow => modRow.data.username !== undefined && modRow.data.username === '')) {
  //       throw new Error(t('lblUsernameIsMissingInTheTable', 'A mandatory field (Username) is missing in the table'))
  //     } else if (this.modifiedRows.some(modRow => modRow.data.email !== undefined && modRow.data.email === '')) {
  //       throw new Error(t('lblEmailIsMissingInTheTable', 'A mandatory field (Email) is missing in the table'))
  //     } else if (
  //       this.modifiedRows.some(modRow => modRow.data.firstName !== undefined && modRow.data.firstName === '')
  //     ) {
  //       throw new Error(t('lblFirstNameIsMissingInTheTable', 'A mandatory field (First Name) is missing in the table'))
  //     } else if (this.modifiedRows.some(modRow => modRow.data.lastName !== undefined && modRow.data.lastName === '')) {
  //       throw new Error(t('lblLastNameIsMissingInTheTable', 'A mandatory field (Last Name) is missing in the table'))
  //     }
  //   } catch (err) {
  //     this.store.displayNotification(
  //       t('lblFailedToUpdateUsers', 'Failed to Update User(s)'),
  //       'error',
  //       true,
  //       extractErrorMessage(err)
  //     )

  //     this.store.stopOverlayLoader()
  //     return
  //   }

  //   this.handleSortingAfterTableSubmit()

  //   await this.store
  //     .postData('users/bulkUpdate', payload)
  //     .then(() => {
  //       if (this.modifiedRows.length === 1) {
  //         this.store.displayNotification(t('lblUserUpdatedSuccessfully', 'User Updated Successfully'), 'success', true)
  //       } else {
  //         this.store.displayNotification(
  //           t('lblUsersUpdatedSuccessfully', 'Users Updated Successfully'),
  //           'success',
  //           true
  //         )
  //       }

  //       this.modifiedRows.length = 0
  //     })
  //     .catch(err => {
  //       this.store.displayNotification(
  //         t('lblFailedToUpdateUsers', 'Failed to Update User(s)'),
  //         'error',
  //         true,
  //         extractErrorMessage(err)
  //       )
  //     })
  //     .finally(() => {
  //       this.store.stopOverlayLoader()
  //     })
  // }

  // public handleDiscardChanges = () => {
  //   // Default behavior for all CRUDs
  //   this.crudCommon.handleDiscardChanges()
  // }

  // === CONTEXT MENU ===
  public handleContextMenuEdit = (row: any) => {
    // Visually highlights the selected row (also handles some internal variables)
    this.tableInstance.handleRowClick(row);

    this.openEditForm(row);
  };

  public handleContextMenuDelete = (row: any) => {
    // single-delete
    if (this.tableInstance.multiSelectedRows.totSelected === 0) {
      this.multiSelectKeyPressed = true;

      this.tableInstance.handleRowClick(row);
      this.tableInstance.handleCellEdit();

      this.multiSelectKeyPressed = false;

      this.deleteModal.onConfirmDelete = () => this.deleteUsers();
      this.deleteModal.description = t("lblAreYouSureYouWantToDeleteUser", 'Are you sure you want to delete user "{1}"?', [row.username]);
      this.deleteModal.visible = true;
    }
    // multi-delete
    else {
      this.deleteModal.onConfirmDelete = () => this.deleteUsers();
      this.deleteModal.description = t("lblAreYouSureYouWantToDeleteCountItems", "Are you sure you want to delete {1} items?", [this.tableInstance.multiSelectedRows.totSelected]);
      this.deleteModal.visible = true;
    }
  };

  public copyText = (value: string) => {
    copyTextToClipboard(value);
    this.store.displayNotification(t("lblCopiedToClipboard", "Copied to Clipboard"), "info", false);
  };

  // === PAYLOAD ===
  public setNewUser() {
    // Original (empty) payload

    this.setUser({
      username: "",
      email: "",
      provider: "local",
      active: true,

      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",

      roles: [],
      // depots: [],
    });

    // This value is used in the CrudFormModal component.
    // We use this value to know if the user has modified any fields within the form
    this.setEntitySnapshot(JSON.stringify(this.user));
  }

  private checkPageAction = () => {
    const action = checkPageAction();

    if (action) {
      switch (action.action) {
        case "createNewUser":
          this.setNewUser();
          this.setIsFormModalVisible(true);
          break;

        default:
          break;
      }
    }
  };
}
